const translationKeys = {
  payments_header_title: 'payments_header_title',
  payments_header_pay_button: 'payments_header_pay_button',
  payments_agreements_label: 'payments_agreements_label',
  payments_upcoming_payments_label: 'payments_upcoming_payments_label',
  payments_pending_total_text: 'payments_pending_total_text',
  payments_pending_item_tag_attachment: 'payments_pending_item_tag_attachment',
  payments_pending_from_account_text: 'payments_pending_from_account_text',
  payments_pending_action_delete: 'payments_pending_action_delete',
  payments_pending_action_accept: 'payments_pending_action_accept',
  payments_form_account_field_label: 'payments_form_account_field_label',
  payments_recipient_field_label: 'payments_recipient_field_label',
  payments_amount_field_label: 'payments_amount_field_label',
  payments_message_field_label: 'payments_message_field_label',
  payments_date_picker_label: 'payments_date_picker_label',
  payments_pending_details_editor_save_button:
    'payments_pending_details_editor_save_button',
  payments_pending_details_editor_remove_button:
    'payments_pending_details_editor_remove_button',
  payments_pending_details_editor_stop_button:
    'payments_pending_details_editor_stop_button',
  payments_pending_details_editor_attachment_label:
    'payments_pending_details_editor_attachment_label',
  payments_message_field_placeholder: 'payments_message_field_placeholder',
  payments_pending_details_editor_header_payment:
    'payments_pending_details_editor_header_payment',
  payments_cid_field_label: 'payments_cid_field_label',
  payments_pending_action_edit_monthly_limit:
    'payments_pending_action_edit_monthly_limit',
  payments_pending_action_change_amount:
    'payments_pending_action_change_amount',
  payments_pending_details_error_title: 'payments_pending_details_error_title',
  payments_pending_details_error_subtitle:
    'payments_pending_details_error_subtitle',
  payments_pending_details_error_button:
    'payments_pending_details_error_button',
  payments_pending_details_save_success:
    'payments_pending_details_save_success',
  payments_pending_details_editor_approve_button:
    'payments_pending_details_editor_approve_button',
  payments_pending_details_delete_button:
    'payments_pending_details_delete_button',
  payments_pending_details_editor_edit_button:
    'payments_pending_details_editor_edit_button',
  payments_header_transfer_button: 'payments_header_transfer_button',
  payments_pending_amount_is_required_error:
    'payments_pending_amount_is_required_error',
  payments_pending_account_is_required_error:
    'payments_pending_account_is_required_error',
  payments_pending_cid_is_required_error:
    'payments_pending_cid_is_required_error',
  payments_pending_date_is_required_error:
    'payments_pending_date_is_required_error',
  payments_pending_message_max_length_error:
    'payments_pending_message_max_length_error',
  payments_pending_amount_zero_info: 'payments_pending_amount_zero_info',
  payments_pending_amount_min_value_error:
    'payments_pending_amount_min_value_error',
  payments_pending_invoice_details_header_digipost:
    'payments_pending_invoice_details_header_digipost',
  payments_pending_invoice_details_header_einvoice:
    'payments_pending_invoice_details_header_einvoice',
  payments_breadcrumb_homepage: 'payments_breadcrumb_homepage',
  payments_breadcrumb_payments: 'payments_breadcrumb_payments',
  payments_pending_cid_validation_max_length:
    'payments_pending_cid_validation_max_length',
  payments_pending_cid_validation_min_length:
    'payments_pending_cid_validation_min_length',
  payments_pending_cell_tag_einvoice: 'payments_pending_cell_tag_einvoice',
  payments_pending_cell_tag_digipost: 'payments_pending_cell_tag_digipost',
  payments_pending_cell_tag_payment_agreement:
    'payments_pending_cell_tag_payment_agreement',
  payments_pending_details_reactivate_payment:
    'payments_pending_details_reactivate_payment',
  payments_pending_delete_invoice_modal_title:
    'payments_pending_delete_invoice_modal_title',
  payments_pending_delete_invoice_modal_subtitle:
    'payments_pending_delete_invoice_modal_subtitle',
  payments_pending_list_modal_cancel: 'payments_pending_list_modal_cancel',
  payments_pending_delete_invoice_modal_delete_button:
    'payments_pending_delete_invoice_modal_delete_button',
  payments_pending_delete_invoice_modal_success:
    'payments_pending_delete_invoice_modal_success',
  payments_pending_delete_invoice_modal_success_close_button:
    'payments_pending_delete_invoice_modal_success_close_button',
  payments_pending_delete_invoice_modal_subtitle_error:
    'payments_pending_delete_invoice_modal_subtitle_error',
  payments_pending_delete_invoice_modal_title_error:
    'payments_pending_delete_invoice_modal_title_error',
  payments_pending_delete_invoice_modal_error_try_again_button:
    'payments_pending_delete_invoice_modal_error_try_again_button',
  payments_pending_invoice_details_confirm_delete_title:
    'payments_pending_invoice_details_confirm_delete_title',
  payments_pending_invoice_details_confirm_delete_subtitle:
    'payments_pending_invoice_details_confirm_delete_subtitle',
  payments_pending_invoice_details_confirm_delete_button:
    'payments_pending_invoice_details_confirm_delete_button',
  payments_pending_invoice_details_delete_success_header:
    'payments_pending_invoice_details_delete_success_header',
  payments_pending_invoice_details_delete_success_message:
    'payments_pending_invoice_details_delete_success_message',
  payments_pending_invoice_details_delete_error_feedback_title:
    'payments_pending_invoice_details_delete_error_feedback_title',
  payments_pending_invoice_details_delete_error_feedback_subtitle:
    'payments_pending_invoice_details_delete_error_feedback_subtitle',
  payments_pending_invoice_details_delete_error_feedback_cancel_button:
    'payments_pending_invoice_details_delete_error_feedback_cancel_button',
  payments_pending_invoice_details_delete_error_feedback_try_again_button:
    'payments_pending_invoice_details_delete_error_feedback_try_again_button',
  payments_pending_list_approve_invoice_error:
    'payments_pending_list_approve_invoice_error',
  payments_pending_approve_invoice_error_title:
    'payments_pending_approve_invoice_error_title',
  payments_pending_approve_invoice_error_subtitle:
    'payments_pending_approve_invoice_error_subtitle',
  payments_pending_approve_invoice_error_try_again_button:
    'payments_pending_approve_invoice_error_try_again_button',
  payments_pending_approve_invoice_success:
    'payments_pending_approve_invoice_success',
  payments_pending_edit_monthly_limit_input_label:
    'payments_pending_edit_monthly_limit_input_label',
  payments_pending_details_edit_monthly_limit_update_button:
    'payments_pending_details_edit_monthly_limit_update_button',
  payments_pending_details_edit_monthly_limit_cancel_button:
    'payments_pending_details_edit_monthly_limit_cancel_button',
  payments_pending_details_edit_monthly_limit_info_message:
    'payments_pending_details_edit_monthly_limit_info_message',
  payments_pending_details_edit_monthly_limit_section_title:
    'payments_pending_details_edit_monthly_limit_section_title',
  payments_pending_details_section_title:
    'payments_pending_details_section_title',
  payments_pending_edit_monthly_limit_api_error_title:
    'payments_pending_edit_monthly_limit_api_error_title',
  payments_pending_edit_monthly_limit_api_error_subtitle:
    'payments_pending_edit_monthly_limit_api_error_subtitle',
  payments_account_name: 'payments_account_name',
  payments_tags_label: 'payments_tags_label',
  payments_pending_edit_monthly_limit_error_title:
    'payments_pending_edit_monthly_limit_error_title',
  payments_pending_edit_monthly_limit_error_subtitle:
    'payments_pending_edit_monthly_limit_error_subtitle',
  payments_pending_edit_monthly_limit_error_cancel_button:
    'payments_pending_edit_monthly_limit_error_cancel_button',
  payments_pending_edit_monthly_limit_error_try_again_button:
    'payments_pending_edit_monthly_limit_error_try_again_button',
  payments_pending_payments_loading_error_title:
    'payments_pending_payments_loading_error_title',
  payments_pending_payments_loading_error_message:
    'payments_pending_payments_loading_error_message',
  payments_pending_payment_loading_error_title:
    'payments_pending_payment_loading_error_title',
  payments_pending_payment_loading_error_message:
    'payments_pending_payment_loading_error_message',
  payments_pending_invoice_loading_error_title:
    'payments_pending_invoice_loading_error_title',
  payments_pending_invoice_loading_error_message:
    'payments_pending_invoice_loading_error_message',
  payments_pending_payments_list_no_data:
    'payments_pending_payments_list_no_data',
  payments_pending_list_expired_invoice_select_new_date_button:
    'payments_pending_list_expired_invoice_select_new_date_button',
  payments_pending_list_expired_invoices_section_title:
    'payments_pending_list_expired_invoices_section_title',
  payments_pending_list_expired_invoices_show_all_button:
    'payments_pending_list_expired_invoices_show_all_button',
  payments_pending_list_expired_invoices_hide_button:
    'payments_pending_list_expired_invoices_hide_button',
  payments_pending_status_stopped_by_user:
    'payments_pending_status_stopped_by_user',
  payments_pending_status_tx_limit_exceeded:
    'payments_pending_status_tx_limit_exceeded',
  payments_pending_status_max_limit_exceeded:
    'payments_pending_status_max_limit_exceeded',
  payments_pending_status_agreement_suspended:
    'payments_pending_status_agreement_suspended',
  payments_pending_status_no_agreement: 'payments_pending_status_no_agreement',
  payments_pending_status_no_funds_stopped:
    'payments_pending_status_no_funds_stopped',
  payments_pending_status_lack_of_funds:
    'payments_pending_status_lack_of_funds',
  payments_pending_status_cid_invalid: 'payments_pending_status_cid_invalid',
  payments_pending_status_technical_failiure_stopped:
    'payments_pending_status_technical_failiure_stopped',
  payments_pending_status_no_disposal: 'payments_pending_status_no_disposal',
  payments_pending_status_not_autorized:
    'payments_pending_status_not_autorized',
  payments_pending_status_deb_account_invalid:
    'payments_pending_status_deb_account_invalid',
  payments_pending_status_cre_account_invalid:
    'payments_pending_status_cre_account_invalid',
  payments_pending_status_bsu_age_exceeded:
    'payments_pending_status_bsu_age_exceeded',
  payments_pending_status_bsu_year_exceeded:
    'payments_pending_status_bsu_year_exceeded',
  payments_pending_status_bsu_tot_exceeded:
    'payments_pending_status_bsu_tot_exceeded',
  payments_pending_status_cancelled: 'payments_pending_status_cancelled',
  payments_pending_status_rejected_other:
    'payments_pending_status_rejected_other',
  payments_pending_status_not_authorised:
    'payments_pending_status_not_authorised',
  payments_pending_invoice_choose_account_button:
    'payments_pending_invoice_choose_account_button',
  payments_pending_invoice_no_account_selected_subtitle:
    'payments_pending_invoice_no_account_selected_subtitle',
  payments_pending_details_reactivate_payment_error_title:
    'payments_pending_details_reactivate_payment_error_title',
  payments_pending_details_reactivate_payment_error_subtitle:
    'payments_pending_details_reactivate_payment_error_subtitle',
  payments_pending_details_reactivate_payment_success:
    'payments_pending_details_reactivate_payment_success',
  payments_pending_details_stop_payment_success:
    'payments_pending_details_stop_payment_success',
  payments_pending_details_confirm_stop_title:
    'payments_pending_details_confirm_stop_title',
  payments_pending_details_confirm_stop_subtitle:
    'payments_pending_details_confirm_stop_subtitle',
  payments_pending_details_confirm_stop_button:
    'payments_pending_details_confirm_stop_button',
  payments_pending_details_stop_payment_error_title:
    'payments_pending_details_stop_payment_error_title',
  payments_pending_details_stop_payment_error_subtitle:
    'payments_pending_details_stop_payment_error_subtitle',
  payments_pending_details_delete_payment_error_title:
    'payments_pending_details_delete_payment_error_title',
  payments_pending_details_delete_payment_error_subtitle:
    'payments_pending_details_delete_payment_error_subtitle',
  payments_pending_details_confirm_delete_title:
    'payments_pending_details_confirm_delete_title',
  payments_pending_details_confirm_delete_subtitle:
    'payments_pending_details_confirm_delete_subtitle',
  payments_pending_details_confirm_delete_button:
    'payments_pending_details_confirm_delete_button',
  payments_pending_details_delete_payment_success:
    'payments_pending_details_delete_payment_success',
  payments_pending_list_reactivate_payment_button:
    'payments_pending_list_reactivate_payment_button',
  payments_pending_list_reactivate_payment_error:
    'payments_pending_list_reactivate_payment_error',
  payments_pending_delete_invoice_modal_loading_spinner_label:
    'payments_pending_delete_invoice_modal_loading_spinner_label',
  payments_pending_invoice_details_date_expired_info_message:
    'payments_pending_invoice_details_date_expired_info_message',
  payments_pending_list_invoice_date_expired_message:
    'payments_pending_list_invoice_date_expired_message',
  payments_pending_einvoices_page_header_title:
    'payments_pending_einvoices_page_header_title',
  payments_pending_einvoices_page_header_subtitle:
    'payments_pending_einvoices_page_header_subtitle',
  payments_pending_einvoices_page_empty_state_text:
    'payments_pending_einvoices_page_empty_state_text',
  payments_pending_einvoices_page_api_error_subtitle:
    'payments_pending_einvoices_page_api_error_subtitle',
  payments_pending_einvoices_page_api_error_title:
    'payments_pending_einvoices_page_api_error_title',
  payments_pending_invoice_approve_success:
    'payments_pending_invoice_approve_success',
  payments_pending_einvoice_forwarded_to_me_dropdown_label:
    'payments_pending_einvoice_forwarded_to_me_dropdown_label',
  payments_pending_einvoice_dropdown_option_my_einvoices:
    'payments_pending_einvoice_dropdown_option_my_einvoices',
  payments_list_header_title: 'payments_list_header_title',
  payments_list_header_subtitle: 'payments_list_header_subtitle',
  payments_header_agreements_button: 'payments_header_agreements_button',
  payments_pending_payments_list_on_behalf_of_no_data:
    'payments_pending_payments_list_on_behalf_of_no_data',
  payments_pending_details_more_options_button_text:
    'payments_pending_details_more_options_button_text',
  payments_pending_invoice_attachment_cell_text:
    'payments_pending_invoice_attachment_cell_text',
  payments_pending_invoice_attachment_cell_error:
    'payments_pending_invoice_attachment_cell_error',
  payments_list_invoice_document_type_reminder_status_message:
    'payments_list_invoice_document_type_reminder_status_message',
  payments_list_invoice_document_type_dunning_status_message:
    'payments_list_invoice_document_type_dunning_status_message',
  payments_list_invoice_document_type_payment_request_status_message:
    'payments_list_invoice_document_type_payment_request_status_message',
  payments_list_invoice_document_type_collection_notice_status_message:
    'payments_list_invoice_document_type_collection_notice_status_message',
  payments_list_invoice_document_type_enforcement_warning_status_message:
    'payments_list_invoice_document_type_enforcement_warning_status_message',
  payments_pending_edit_monthly_limit_get_payment_error_subtitle:
    'payments_pending_edit_monthly_limit_get_payment_error_subtitle',
  payments_pending_edit_monthly_limit_reactivate_payment_error_subtitle:
    'payments_pending_edit_monthly_limit_reactivate_payment_error_subtitle',
  payments_pending_direct_debit_update_monthly_limit_success:
    'payments_pending_direct_debit_update_monthly_limit_success',
  payments_pending_cell_tag_einvoice_on_behalf_of:
    'payments_pending_cell_tag_einvoice_on_behalf_of',
};

Object.freeze(translationKeys);

export default translationKeys;
